import { LoadingOverlay, Paper, Stack, Title } from "@mantine/core";
import { CodeHighlight } from "@mantine/code-highlight";

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// Lookup Result
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

type LookupResultProps = {
  readonly isLoading: boolean;
  readonly lookupResult: object | object[];
};

export function LookupResult({ isLoading, lookupResult }: LookupResultProps) {
  return (
    <Stack gap="xs" w="100%">
      <Title order={6}>Lookup Result:</Title>

      <Paper pos="relative" withBorder={true}>
        <LoadingOverlay visible={isLoading} />

        <CodeHighlight
          language="json"
          code={JSON.stringify(lookupResult, null, 2)}
        />
      </Paper>
    </Stack>
  );
}
